'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAccounts$002dView$0024 from "./presto.-Accounts-View$.js";
import * as $j_presto$002e$002dFetcher$0024 from "./presto.-Fetcher$.js";
import * as $j_presto$002e$002dFetcher$0024$002dFetch$002dRequest$0024 from "./presto.-Fetcher$-Fetch-Request$.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002426 from "./presto.-Login-Page-View$$anon$26.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$() {
}
export { $c_Lpresto_LoginPageView$ as $c_Lpresto_LoginPageView$ };
$p = $c_Lpresto_LoginPageView$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$;
/** @constructor */
function $h_Lpresto_LoginPageView$() {
}
export { $h_Lpresto_LoginPageView$ as $h_Lpresto_LoginPageView$ };
$h_Lpresto_LoginPageView$.prototype = $p;
$p.cHv = (function(request) {
  var options = $j_presto$002e$002dFetcher$0024$002dFetch$002dRequest$0024.$m_Lpresto_Fetcher$FetchRequest$().aK();
  return new $j_presto$002e$002dAccounts$002dView$0024.$c_Lpresto_Fetcher$PrestoRequest($j_presto$002e$002dFetcher$0024.$m_Lpresto_Fetcher$().aF, "/login/provider", options).bz(request, new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002426.$c_Lpresto_LoginPageView$$anon$26(this));
});
var $d_Lpresto_LoginPageView$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$, "presto.LoginPageView$", ({
  M1: 1
}));
export { $d_Lpresto_LoginPageView$ as $d_Lpresto_LoginPageView$ };
var $n_Lpresto_LoginPageView$;
function $m_Lpresto_LoginPageView$() {
  if ((!$n_Lpresto_LoginPageView$)) {
    $n_Lpresto_LoginPageView$ = new $c_Lpresto_LoginPageView$();
  }
  return $n_Lpresto_LoginPageView$;
}
export { $m_Lpresto_LoginPageView$ as $m_Lpresto_LoginPageView$ };
//# sourceMappingURL=presto.-Login-Page-View$.js.map
